import { Component } from '@angular/core';

@Component({
	templateUrl: '../../../../../../assets/svg/instagram.svg',
})
export class InstagramComponent {}
